import { ClassifierType } from 'types/generated/graphql';
import { FiltersParams } from 'types/params';

export const classifierToFiltersParams = (
    type: ClassifierType,
): FiltersParams => {
    switch (type) {
        case ClassifierType.Genre:
            return FiltersParams.genres;
        case ClassifierType.Instrument:
            return FiltersParams.instruments;
        case ClassifierType.Sfx:
            return FiltersParams.sfxs;
        case ClassifierType.Tag:
        case ClassifierType.Free:
            return FiltersParams.tags;
    }
};
